/* import __COLOCATED_TEMPLATE__ from './create-shell-company.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { dropTask } from 'ember-concurrency';
import { handleErrorResponse } from 'sh-www/utils/handles-errors';
import { closeModal } from 'sh-www/utils/modal-controls';
import { COMPANY } from 'sh-www/models/company';

class CreateShellCompanyModalComponent extends Component {
  @service('commands.company-commands')
  companyCommands;

  @tracked name = '';
  @tracked locationInputValue = '';
  @tracked location = null;
  @tracked errors = { };

  get formDisabled() {
    return !this.name || !this.location || this.handleSubmit.isRunning;
  }

  @action
  handleInput(field, value) {
    this[field] = value;

    if (this.errors[field]) {
      this.errors = { ...this.errors, [field]: undefined };
    }
  }

  @action
  handleLocationInput(value) {
    this.locationInputValue = value;

    if (this.errors.location_id) {
      this.errors = { ...this.errors, location_id: undefined };
    }
  }

  @action
  handleLocationChange(location) {
    this.location = location;
    this.locationInputValue = location?.formattedAddress ?? '';

    if (this.errors.location_id) {
      this.errors = { ...this.errors, location_id: undefined };
    }
  }

  @dropTask
  *handleSubmit(e) {
    e.preventDefault();

    this.errors = { };

    try {
      const company = yield this.companyCommands.createNewCompany({
        name: this.name,
        opt_locationId: this.location.id,
        opt_type: COMPANY.TYPES.SHELL,
      });

      this.args.model.onComplete(company);
    } catch (error) {
      handleErrorResponse(this, error, ['name', 'location_id']);
      return;
    }

    closeModal(this);
  }
}

export default CreateShellCompanyModalComponent;
